export enum ErrorCode {
  InvalidCredentials = 1,
  InvalidAdminCode = 2,
  InvalidProgramCode = 3,
  IncorrectPassword = 4,
  InvalidPassword = 5,
  PasswordExists = 6,
  AccessTokenExpired = 7,
  InvalidAccessToken = 8,
  AccessTokenRequire = 9,
  InvalidStudentId = 10,
  PasswordLinkExpired = 11,
  InvalidStudentCenter = 12,
  InvalidAdminCenter = 13,
  InvalidAdminId = 14,
  InvalidRefreshToken = 15,
  InvalidStartCode = 21,
  InvalidAbortCode = 28,
  InvalidStudentCode = 16,
  AssessmentNotAvailable = 42,
  AuthHeaderRequired = 17,
  InvalidAssessmentId = 18,
  AssessmentNotLive = 19,
  AssessmentAlreadyTaken = 20,
  TestAlreadyGoingOn = 22,
  InvalidAttemptId = 24,
  InvalidInvigilatorId = 25,
  InvalidProgramId = 26,
  InvalidSubjectId = 27,
  AttemptLimitExceeded = 29,
  InvalidQuestionId = 30,
  SubjectNotFound = 31,
  LevelNotFound = 32,
  MissionNotFound = 33,
  StagesNotFound = 34,
  ModuleNotFound = 35,
  InvalidMissionId = 36,
  InvalidStageId = 37,
  InvalidModuleId = 38,
  StageLocked = 39,
  IncompleteEngagementStrategy = 40,
  InvalidLevelId = 41,
  QuestionNotFound = 43,
  PracticeContentNotFound = 44,
  StageCompleted = 45,
  MissionLocked = 46,
  IncompleteMission = 47,
  AdminAndProgramCodeMismatch = 49,
}

interface ErrorData {
  code?: number;
  message?: string;
}

export const getErrorMessageFromCode = (code: ErrorCode): string => {
  switch (code) {
    case ErrorCode.InvalidAdminCode: {
      return 'Invalid Admin Code. Please check and try again.';
    }
    case ErrorCode.InvalidProgramCode: {
      return 'Invalid Program Code. Please re-enter the correct code.';
    }
    case ErrorCode.IncorrectPassword: {
      return 'Incorrect Password. Please try again.';
    }
    case ErrorCode.InvalidPassword: {
      return 'Incorrect Password. Please try again.';
    }
    case ErrorCode.PasswordExists: {
      return 'Password already exists.';
    }
    case ErrorCode.InvalidStartCode: {
      return 'Invalid Code. Please try again.';
    }
    case ErrorCode.InvalidAbortCode: {
      return 'Invalid Code. Please try again.';
    }
    case ErrorCode.InvalidStudentCode: {
      return 'Invalid Student Code. Please try again.';
    }
    case ErrorCode.AdminAndProgramCodeMismatch: {
      return 'Program and Admin Code do not match. Please try again!';
    }
    default: {
      return 'An error occurred. Please try again.';
    }
  }
};

export const getErrorInfoFromCode = (data: ErrorData) => {
  if (!data.code && !data.message) {
    return {
      key: 'somethingWentWrong',
    };
  }
  if (!data.code && data.message) {
    return {
      key: 'genericMessage',
    };
  }

  let errorKey;
  switch (data.code) {
    case ErrorCode.InvalidCredentials: {
      errorKey = 'invalidCredentials';
      break;
    }
    case ErrorCode.InvalidAdminCode: {
      errorKey = 'invalidAdminCode';
      break;
    }
    case ErrorCode.InvalidProgramCode: {
      errorKey = 'invalidProgramCode';
      break;
    }
    case ErrorCode.IncorrectPassword: {
      errorKey = 'incorrectPassword';
      break;
    }
    case ErrorCode.InvalidPassword: {
      errorKey = 'invalidPassword';
      break;
    }
    case ErrorCode.PasswordExists: {
      errorKey = 'passwordAlreadyExist';
      break;
    }
    case ErrorCode.InvalidStartCode: {
      errorKey = 'incorrectTestCode';
      break;
    }
    case ErrorCode.InvalidAbortCode: {
      errorKey = 'incorrectAbortCode';
      break;
    }
    case ErrorCode.AccessTokenExpired: {
      errorKey = 'accessTokenExpired';
      break;
    }
    case ErrorCode.InvalidAccessToken: {
      errorKey = 'invalidAccessToken';
      break;
    }
    case ErrorCode.AccessTokenRequire: {
      errorKey = 'accessTokenRequire';
      break;
    }
    case ErrorCode.InvalidStudentId: {
      errorKey = 'invalidStudentId';
      break;
    }
    case ErrorCode.PasswordLinkExpired: {
      errorKey = 'passwordLinkExpired';
      break;
    }
    case ErrorCode.InvalidStudentCenter: {
      errorKey = 'invalidStudentCenter';
      break;
    }
    case ErrorCode.InvalidAdminCenter: {
      errorKey = 'invalidAdminCenter';
      break;
    }
    case ErrorCode.InvalidAdminId: {
      errorKey = 'invalidAdminId';
      break;
    }
    case ErrorCode.InvalidRefreshToken: {
      errorKey = 'invalidRefreshToken';
      break;
    }
    case ErrorCode.InvalidStudentCode: {
      errorKey = 'invalidStudentCode';
      break;
    }
    case ErrorCode.AuthHeaderRequired: {
      errorKey = 'authHeaderRequired';
      break;
    }
    case ErrorCode.InvalidAssessmentId: {
      errorKey = 'invalidAssessmentId';
      break;
    }
    case ErrorCode.AssessmentNotLive: {
      errorKey = 'assessmentNotLive';
      break;
    }
    case ErrorCode.AssessmentAlreadyTaken: {
      errorKey = 'assessmentAlreadyTaken';
      break;
    }
    case ErrorCode.TestAlreadyGoingOn: {
      errorKey = 'testAlreadyGoingOn';
      break;
    }
    case ErrorCode.InvalidAttemptId: {
      errorKey = 'invalidAttemptId';
      break;
    }
    case ErrorCode.InvalidInvigilatorId: {
      errorKey = 'invalidInvigilatorId';
      break;
    }
    case ErrorCode.InvalidProgramId: {
      errorKey = 'invalidProgramId';
      break;
    }
    case ErrorCode.InvalidSubjectId: {
      errorKey = 'invalidSubjectId';
      break;
    }
    case ErrorCode.AttemptLimitExceeded: {
      errorKey = 'attemptLimitExceeded';
      break;
    }
    case ErrorCode.InvalidQuestionId: {
      errorKey = 'invalidQuestionId';
      break;
    }
    case ErrorCode.SubjectNotFound: {
      errorKey = 'subjectNotFound';
      break;
    }
    case ErrorCode.LevelNotFound: {
      errorKey = 'levelNotFound';
      break;
    }
    case ErrorCode.MissionNotFound: {
      errorKey = 'missionsNotFound';
      break;
    }
    case ErrorCode.StagesNotFound: {
      errorKey = 'stagesNotFound';
      break;
    }
    case ErrorCode.ModuleNotFound: {
      errorKey = 'moduleNotFound';
      break;
    }
    case ErrorCode.InvalidMissionId: {
      errorKey = 'invalidMissionId';
      break;
    }
    case ErrorCode.InvalidStageId: {
      errorKey = 'invalidStageId';
      break;
    }
    case ErrorCode.InvalidModuleId: {
      errorKey = 'invalidModuleId';
      break;
    }
    case ErrorCode.StageLocked: {
      errorKey = 'lockedStag';
      break;
    }
    case ErrorCode.IncompleteEngagementStrategy: {
      errorKey = 'incompleteEngagementStrategy';
      break;
    }
    case ErrorCode.InvalidLevelId: {
      errorKey = 'invalidLevelId';
      break;
    }
    case ErrorCode.AssessmentNotAvailable: {
      errorKey = 'assessmentNotAvailable';
      break;
    }
    case ErrorCode.QuestionNotFound: {
      errorKey = 'questionNotFound';
      break;
    }
    case ErrorCode.PracticeContentNotFound: {
      errorKey = 'practiceContentNotFound';
      break;
    }
    case ErrorCode.StageCompleted: {
      errorKey = 'stageCompleted';
      break;
    }
    case ErrorCode.MissionLocked: {
      errorKey = 'missionLocked';
      break;
    }
    case ErrorCode.IncompleteMission: {
      errorKey = 'incompleteMission';
      break;
    }
    default: {
      errorKey = 'unknownError';
    }
  }
  return { key: errorKey };
};
